import { render, staticRenderFns } from "./orderDetailsPaymentPlan.vue?vue&type=template&id=2255894c&scoped=true"
import script from "./orderDetailsPaymentPlan.vue?vue&type=script&lang=js"
export * from "./orderDetailsPaymentPlan.vue?vue&type=script&lang=js"
import style0 from "./orderDetailsPaymentPlan.vue?vue&type=style&index=0&id=2255894c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255894c",
  null
  
)

export default component.exports